import { render, staticRenderFns } from "./optionServiceRemark.vue?vue&type=template&id=5491694c&scoped=true&"
import script from "./optionServiceRemark.vue?vue&type=script&lang=js&"
export * from "./optionServiceRemark.vue?vue&type=script&lang=js&"
import style0 from "./optionServiceRemark.vue?vue&type=style&index=0&id=5491694c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5491694c",
  null
  
)

export default component.exports